import apiAuctions from "../../api/apiAuctions"

const state = {
    isOpen: false,
    isOpenGallery: false,
    options: {
        index: 0
    },
    optionsGallery: {},
    items: [],
    car: {}
}
const getters = {
    getResultGalleryStatus: (state) => {
        return state.isOpen
    },
    getResultGalleryItems: (state) => {
        return state.items
    },
    getResultGalleryOptions: (state) => {
        return state.options
    },
    getResultGalleryCar: (state) => {
        return state.car
    }
}

const mutations = {
    changeGalleryStatus: (state, status) => {
        state.isOpen = status
    },
    changeGalleryCar: (state, car) => {
        state.car = car
    },
    changeGalleryOptions: (state, options) => {
        state.options = options
    },
    changeGalleryItems: (state, items) => {
        let photos = []
        items.forEach(function (element) {
            photos.push({
                src: element + '',
                w: 800,
                h: 600,
                title: ''
            })
        })
        state.items = photos
    },
    changeCarGalleryItems: (state, items) => {
        let photos = []
        items.forEach(function (element) {
            photos.push({
                src: element,
                w: 800,
                h: 600,
                title: ''
            })
        })
        state.items = photos
    },
    resetGallery: (state) => {
        state.isOpen = false
        state.isOpenGallery = false
        state.options = { index: 0}
        state.optionsGallery = {}
        state.items = []
    }
}

const actions = {
    setResultGalleryCar: ({commit}, car) => {
        commit('changeGalleryCar', car)
    },
    setResultGalleryToDefault: ({commit}) => {
        commit('resetGallery')
    },
    setResultGalleryItems: ({commit}, items) => {
        commit('changeGalleryItems', items)
    },
    setCarGalleryItems: ({commit}, items) => {
        commit('changeCarGalleryItems', items)
    },
    setResultGalleryOptions: ({commit}, options) => {
        commit('changeGalleryOptions', options)
    },
    setResultGalleryStatus: ({commit}, status) => {
        commit('changeGalleryStatus', status)
    },
    fetchAllLotPhotosByLotId: ({commit}, lotId) => {
        apiAuctions
            .getAllLotPhotos(lotId)
            .then((response) => {
                commit('changeGalleryItems', response.data.split('#'))
                commit('changeGalleryStatus', true)
            })
            .catch(error => console.log(error))
    }
}

export default { state, getters, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/resultGallery.js